<div class="d-flex justify-content-between justify-content-lg-end me-3">
  <img
    *ngIf="!(configurationService.isTabletOrLarger$ | async)"
    class="logo cursor-pointer"
    [src]="primaryLogoUrl$ | async"
    alt="Logo"
  />
  <language-switcher></language-switcher>
</div>
